<script lang="ts" setup>
import { DropdownItem, Icon, Indicator } from '@brighterly/lib-lumee-ui'

import { NotificationPointer } from '@shared/ui/labels'
import { useSettingsStore } from '@shared/model'
import { AppRoute } from '@shared/config'
import { trackEvent } from '@shared/lib/amplitude'

defineOptions({
  name: 'LinkReferral',
})

const emit = defineEmits<{
  click: []
}>()

const settingsStore = useSettingsStore()

const text = 'Referrals'

const route = useRoute()
const selected = computed(() => route.path === AppRoute.Referral)
const isProgramNew = computed<boolean>(() => settingsStore.isShowNewReferralProgram)
const pointer = computed<boolean>(() => settingsStore.isShowNewReferralCredits)
const hasTrailingContent = computed<boolean>(() => isProgramNew.value || pointer.value)

const handleClick = (): void => {
  if (selected.value) return

  trackEvent('Link_click', { feature: 'navigation', name: 'referral', text, url: AppRoute.Referral })
  emit('click')
  void navigateTo(AppRoute.Referral)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    :aria-current="selected ? 'page' : undefined"
    :selected="selected"
    @click="handleClick"
  >
    <template #leading>
      <Icon
        name="circle-dollar"
        size="md"
        color="default"
      />
    </template>
    <template
      v-if="hasTrailingContent"
      #trailingContent
    >
      <Indicator
        v-if="isProgramNew"
        view="new"
      />
      <NotificationPointer
        v-if="pointer"
        view="default"
        color="amber"
      />
    </template>
  </DropdownItem>
</template>
